import React from 'react';
import { CircularProgress, Box } from '@material-ui/core';

export default () => (
  <Box textAlign="center" py={2}>
    <CircularProgress size={24} disableShrink />
  </Box>
);
